import type { StakeholderType } from './Stakeholder'
import type { GatshipSearchOperator } from './Search'

export enum USER_STATE_KEYS_GLOBAL {
  'theme'
}

export type UserStateKeyGlobal = keyof typeof USER_STATE_KEYS_GLOBAL

// Type mapping for global keys to their value types
export interface UserStateValueMapGlobal extends Record<string, unknown> {
  theme: 'dark' | 'light' | 'system'
}

export const DEFAULT_USER_STATE_VALUE_MAP_GLOBAL: UserStateValueMapGlobal = {
  theme: 'system'
}

// Add new keys to this enum
export enum USER_STATE_KEYS_ACTIVE_DB {
  'stakeholders.recently-visited',
  'stakeholders.saved-searches'
}

// This type is used to map the active-db keys to their value types
// Add new keys + types to this interface
// The interface must include all keys from USER_STATE_KEYS_ACTIVE_DB
export interface UserStateValueMapActiveDb extends Record<string, unknown> {
  'stakeholders.recently-visited': RecentVisitItem[]
  'stakeholders.saved-searches': SearchBookmark[]
}

// This is the default value for the active-db state
// Add new keys + default values to this interface
export const DEFAULT_USER_STATE_VALUE_MAP_ACTIVE_DB: UserStateValueMapActiveDb =
  {
    'stakeholders.recently-visited': [],
    'stakeholders.saved-searches': []
  }

// This type is used to get the key of the active-db state
export type UserStateKeyActiveDb = keyof typeof USER_STATE_KEYS_ACTIVE_DB

// SearchBookmark type - extracted from stakeholder-search-provider.vue
export interface SearchBookmark {
  /** The id of the bookmark. */
  id: string
  /** The title of the bookmark. */
  title: string
  /** The context of the bookmark. */
  context: string
  /** The search term of the bookmark. */
  searchTerm?: string
  /** The database id of the bookmark. */
  databaseId?: string
  /** The active filters of the bookmark. */
  activeFilters?: Record<
    string,
    {
      filterValue: string | undefined
      operator: GatshipSearchOperator
      fieldName: string
    }
  >
  /** The timestamp of the bookmark. */
  timestamp: number
}

export interface RecentVisitItem {
  id: string
  text: string
  type: StakeholderType
  timestamp: number
}
